/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { GET_LISTDATA } from "../../actions";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { apiUrl, adminlimit, headerconfig } from "../Settings/Config";
import { format } from "date-fns";
import {
  showContaimerLoader,
  userID,
  showPriceValue,
  encodeValue,
} from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
var module = "reports/";
var moduleName = "Purchase Statistics Report";

class List extends Component {
  constructor(props) {
    super(props);
    console.log(this.props, "this.props");
    let reportType = this.props.match.params?.reportType || "";
    this.state = {
      userID: userID(),
      loading: true,
      totalRecords: 0,
      totalPage: 0,
      totalPurchase:0,
      currentPage: 1,
      listdata: [],

      recivedloading: true,
      recivedtotalRecords: 0,
      recivedtotalPage: 0,
      totalpurchasePaid:0,
      recivedcurrentPage: 1,
      recivedlistdata: [],

      pendingloading: true,
      pendingtotalRecords: 0,
      pendingtotalPage: 0,
      balanceBillAmount:0,
      pendingcurrentPage: 1,
      pendinglistdata: [],

      reportType: reportType,
      start_date: "",
      end_date: "",
      vendor: "",
      vendorList: [],
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  componentDidMount() {
    this.loadVendor();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
        totalPurchase: nextProps.totalPurchase,
      });
    }

    let reportType = nextProps.match.params?.reportType || "";
    if(reportType!==this.state.reportType) {
        this.setState({reportType: reportType})
    }

  }
  searchList() {
    this.setState({ loading: true, recivedloading:true, pendingloading:true }, function () {
      this.loadList(1);
      this.loadRecivedList(1);
      this.loadPendingList(1);
      
    });
  }
  
  resetSearch() {
    this.setState(
      {
        loading: true,
        recivedloading:true,
        pendingloading:true,
        start_date: "",
        end_date: "",
        vendor: "",
      },
      function () {
        this.loadList(1);
        this.loadRecivedList(1);
        this.loadPendingList(1);
      }
    );
  }
  loadList(offset) {
    var addParams = "";
    if (this.state.vendor?.value) {
      addParams += "&vendor=" + this.state.vendor.value;
    }

    if (this.state.start_date) {
      addParams +=
        "&start_date=" + format(new Date(this.state.start_date), "yyyy-MM-dd");
    }
    if (this.state.end_date) {
      addParams +=
        "&end_date=" + format(new Date(this.state.end_date), "yyyy-MM-dd");
    }
    var params = {
      params:
        "limit=" +
        adminlimit +
        "&offset=" +
        offset +
        "&userID=" +
        this.state.userID +
        addParams,
      url: apiUrl + "reports/purchase",
    };
    this.props.getListData(params);
  }


  loadRecivedList(offset) {
    var addParams = "";
    if (this.state.vendor?.value) {
      addParams += "&vendor=" + this.state.vendor.value;
    }

    if (this.state.start_date) {
      addParams +=
        "&start_date=" + format(new Date(this.state.start_date), "yyyy-MM-dd");
    }
    if (this.state.end_date) {
      addParams +=
        "&end_date=" + format(new Date(this.state.end_date), "yyyy-MM-dd");
    }   

    var urlShringTxt =
      apiUrl + "reports/recivedpurchase?limit=" +
        adminlimit +
        "&offset=" +
        offset +
        "&userID=" +
        this.state.userID +
        addParams;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        var result = res.data.result;       
        this.setState({recivedloading:false, recivedlistdata:result, recivedtotalRecords:res.data.totalRecords, recivedtotalPage:res.data.totalPages, totalpurchasePaid:res.data.totalpurchasePaid})       
      } else {
        this.setState({recivedloading:false, recivedlistdata:[],  recivedtotalRecords: 0, recivedtotalPage: 0, totalpurchasePaid:0})
      }
    });
  }

  loadPendingList(offset) {
    var addParams = "";
    if (this.state.vendor?.value) {
      addParams += "&vendor=" + this.state.vendor.value;
    }

    if (this.state.start_date) {
      addParams +=
        "&start_date=" + format(new Date(this.state.start_date), "yyyy-MM-dd");
    }
    if (this.state.end_date) {
      addParams +=
        "&end_date=" + format(new Date(this.state.end_date), "yyyy-MM-dd");
    }   

    var urlShringTxt =
      apiUrl + "reports/pendingpurchase?limit=" +
        adminlimit +
        "&offset=" +
        offset +
        "&userID=" +
        this.state.userID +
        addParams;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        var result = res.data.result;       
        this.setState({pendingloading:false, pendinglistdata:result, pendingtotalRecords:res.data.totalRecords, pendingtotalPage:res.data.totalPages, balanceBillAmount:res.data.balanceBillAmount})       
      } else {
        this.setState({pendingloading:false, pendinglistdata:[],  pendingtotalRecords: 0, pendingtotalPage: 0, balanceBillAmount:0})
      }
    });
  }

  loadVendor() {
    var urlShringTxt =
      apiUrl + "vendors/dropdownlist?&userID=" + this.state.userID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState(
          { vendorList: res.data.result},
          () => {
            this.loadList(1);
            this.loadRecivedList(1);
            this.loadPendingList(1);
            
          }
        );
      } else {
        this.loadList(1);
        this.loadRecivedList(1);
      }
    });
  }
  sateValChange = (field, value, additionalParam) => {
    if (field === "page" && additionalParam==='total') {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          this.loadList(value);
        }
      );
    }else  if (field === "page" && additionalParam==='recived') {
      this.setState(
        {
          recivedloading: true,
          recivedcurrentPage: value,
        },
        function () {
          this.loadRecivedList(value);
        }
      );
    }else  if (field === "page" && additionalParam==='pending') {
      this.setState(
        {
          pendingloading: true,
          pendingcurrentPage: value,
        },
        function () {
          this.loadPendingList(value);
        }
      );
    }
  };
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }
  handleChangeDate(name, value) {
    this.setState({ [name]: value });
  }

  gotoDetails() {

  }

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="statistics-report" />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                  </div>

                  <div className="row">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="form-row">
                            <div className="col-md-3">
                              <Select
                                value={this.state.vendor}
                                onChange={this.handleSelectChange.bind(
                                  this,
                                  "vendor"
                                )}
                                placeholder="Select Vendor"
                                isClearable={true}
                                options={this.state.vendorList}
                              />
                            </div>
                            <div className="col-md-2">
                              <div className="form-floating form-floating-outline">
                                <DatePicker
                                  peekNextMonth
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  className="form-control"
                                  selected={this.state.start_date}
                                  dateFormat="dd-MM-yyyy"
                                  placeholderText="Start Date"
                                  onChange={this.handleChangeDate.bind(
                                    this,
                                    "start_date"
                                  )}
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-floating form-floating-outline">
                                <DatePicker
                                  peekNextMonth
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  className="form-control"
                                  selected={this.state.end_date}
                                  minDate={
                                    this.state.start_date !== ""
                                      ? this.state.start_date
                                      : ""
                                  }
                                  dateFormat="dd-MM-yyyy"
                                  placeholderText="Start Date"
                                  onChange={this.handleChangeDate.bind(
                                    this,
                                    "end_date"
                                  )}
                                />
                              </div>
                            </div>

                            <div className="col-md-3">
                              <a
                                href={void 0}
                                className="btn btn-primary"
                                onClick={this.searchList.bind(this)}
                              >
                                Search
                              </a>
                              <a
                                href={void 0}
                                className="btn btn-secondary offset-1"
                                onClick={this.resetSearch.bind(this)}
                              >
                                Reload
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab-menu-heading">
                    <div class="tabs-menu">                        
                        <ul class="nav panel-tabs panel-secondary">
                            <li>
                                <Link to={`/report/statistics/purchase/total`} class={this.state.reportType==='total'?"active":''}>
                                    <span>
                                        <i class="fe fe-user me-1"></i>
                                    </span>
                                    Total Purchase
                                </Link>
                            </li>
                            <li>
                              <Link to={`/report/statistics/purchase/recived`} class={this.state.reportType==='recived'?"active":''}>
                                    <span>
                                        <i class="fe fe-user me-1"></i>
                                    </span>
                                    Recived Bill
                              </Link>
                            </li>
                            <li>
                              <Link to={`/report/statistics/purchase/pending`} class={this.state.reportType==='pending'?"active":''}>
                                    <span>
                                        <i class="fe fe-user me-1"></i>
                                    </span>
                                    Payable Bill
                              </Link>
                            </li>
                            
                        </ul>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="card">
                        {this.state.reportType==='total' && (
                          <div>
                            {this.state.loading ? (
                              showContaimerLoader()
                            ) : (
                              <div>
                                {parseInt(this.state.totalPage) > 0 && (
                                  <div className="card-header">
                                    <h3 className="card-title" style={{width:'80%'}}>
                                      <b>{this.state.currentPage}</b> -{" "}
                                      <b> {this.state.totalPage}</b> of{" "}
                                      <b> {this.state.totalRecords} </b>
                                      Total Purchase
                                    </h3>
                                    <div className="float-sm-end ">
                                      <h3 className="card-title float-sm-end">Total Purchase: {showPriceValue(this.state.totalPurchase)}</h3>
                                    </div>
                                    
                                  </div>
                                )}
                                <div className="card-body">
                                  <div className="table-responsive">
                                    <table className="table text-nowrap text-md-nowrap mb-0">
                                      <thead>
                                        <tr>
                                          <th>Invoice Number</th>
                                          <th>Purchase Date</th>
                                          <th>Purchase Amount</th>
                                          <th>GST Amount</th>
                                          <th>Total Purchase Amount</th>
                                          <th>Paid Amount</th>
                                          <th>Balance Amount</th>
                                          <th>Vendor Name</th>
                                          <th>Vendor Person</th>
                                          <th>Mobile </th>
                                          <th>Email</th>
                                          <th>Address</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.state.listdata.length > 0 ? (
                                          this.state.listdata.map((item, index) => {
                                            return (
                                              <tr key={index}>
                                                <td>{item.purchaseInvoiceNumber}</td>
                                                <td>
                                                  {format(
                                                    new Date(item.purchaseDate),
                                                    "dd-MM-yyyy"
                                                  )}
                                                </td>
                                                <td>
                                                  {showPriceValue(item.purchaseSubtotal)}
                                                </td>
                                                <td>
                                                  {showPriceValue(item.purchaseGSTAmount)}
                                                </td>
                                                <td>
                                                  {showPriceValue(item.purchaseAmount)}
                                                </td>
                                                <td>
                                                  {showPriceValue(
                                                    item.purchasePayAmount
                                                  )}
                                                </td>
                                                <td>
                                                  {showPriceValue(
                                                    item.purchaseBalanceAmount
                                                  )}
                                                </td>
                                                <td>{item.vendorName}</td>
                                                <td>
                                                  {item.vendorContactPerson}
                                                </td>
                                                <td>{item.vendorPhone}</td>
                                                <td>{item.vendorEmail}</td>
                                                <td>
                                                  {item.vendorAddress}
                                                </td>
                                              </tr>
                                            );
                                          })
                                        ) : (
                                          <tr>
                                            <td className="text-center" colSpan={11}>
                                              No {moduleName} Found
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                  <Pagenation
                                    params={{
                                      totalRecords: this.state.totalRecords,
                                      totalPage: this.state.totalPage,
                                      currentPage: this.state.currentPage,
                                      additionalParam:'total',
                                    }}                                    
                                    sateValChange={this.sateValChange}
                                  />
                                  
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                        {this.state.reportType==='recived' && (
                          <div>
                            {this.state.recivedloading ? (
                              showContaimerLoader()
                            ) : (
                              <div>
                                {parseInt(this.state.recivedtotalPage) > 0 && (
                                  <div className="card-header">
                                    <h3 className="card-title" style={{width:'80%'}}>
                                      <b>{this.state.recivedcurrentPage}</b> -{" "}
                                      <b> {this.state.recivedtotalPage}</b> of{" "}
                                      <b> {this.state.recivedtotalRecords} </b>
                                      Paid Bill
                                    </h3>
                                    <div className="float-sm-end ">
                                      <h3 className="card-title float-sm-end">Total Paid Amount: {showPriceValue(this.state.totalpurchasePaid)}</h3>
                                    </div>
                                  </div>
                                )}
                                <div className="card-body">
                                  <div className="table-responsive">
                                    <table className="table text-nowrap text-md-nowrap mb-0">
                                      <thead>
                                        <tr>
                                          <th>Invoice Number</th>
                                          <th>Recived Amount</th>
                                          <th>Modeof Payment</th>
                                          <th>Payment Reference Number</th>
                                          <th>Payment Date</th>
                                          <th>Vendor Name</th>
                                          <th>Vendor Person</th>
                                          <th>Mobile </th>
                                          <th>Email</th>
                                          <th>Address</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.state.recivedlistdata.length > 0 ? (
                                          this.state.recivedlistdata.map((item, index) => {
                                            return (
                                              <tr key={index}>
                                                <td>{item.purchaseInvoiceNumber}</td>
                                                <td>
                                                  <b>{showPriceValue(item.amount)}</b>
                                                </td>
                                                <td>{item.modeofPayment}</td>
                                                <td>{item.paymentReferenceNumber}</td>
                                                <td>
                                                  {item.amountCreatedOn !== ""
                                                    ? format(
                                                        new Date(item.amountCreatedOn),
                                                        "dd-MM-yyyy"
                                                      )
                                                    : ""}
                                                </td>
                                                <td>{item.vendorName}</td>
                                                <td>
                                                  {item.vendorContactPerson}
                                                </td>
                                                <td>{item.vendorPhone}</td>
                                                <td>{item.vendorEmail}</td>
                                                <td>
                                                  {item.vendorAddress}
                                                </td>
                                              </tr>
                                            );
                                          })
                                        ) : (
                                          <tr>
                                            <td className="text-center" colSpan={11}>
                                              No {moduleName} Found
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                  <Pagenation
                                    params={{
                                      totalRecords: this.state.recivedtotalRecords,
                                      totalPage: this.state.recivedtotalPage,
                                      currentPage: this.state.recivedcurrentPage,
                                      additionalParam:'recived'
                                    }}
                                    sateValChange={this.sateValChange}
                                  />                                  
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                        {this.state.reportType==='pending' && (
                          <div>
                            {this.state.pendingloading ? (
                              showContaimerLoader()
                            ) : (
                              <div>
                                {parseInt(this.state.pendingtotalPage) > 0 && (
                                  <div className="card-header">
                                    <h3 className="card-title" style={{width:'75%'}}>
                                      <b>{this.state.pendingcurrentPage}</b> -{" "}
                                      <b> {this.state.pendingtotalPage}</b> of{" "}
                                      <b> {this.state.pendingtotalRecords} </b>
                                      Payable Bill
                                    </h3>
                                    <div className="float-sm-end ">
                                      <h3 className="card-title float-sm-end">Total Payable Amount: {showPriceValue(this.state.balanceBillAmount)}</h3>
                                    </div>
                                  </div>
                                )}
                                <div className="card-body">
                                  <div className="table-responsive">
                                    <table className="table text-nowrap text-md-nowrap mb-0">
                                      <thead>
                                        <tr>
                                        <th>Invoice Number</th>
                                          <th>Purchase Date</th>
                                          <th>Purchase Amount</th>
                                          <th>Balance Amount</th>
                                          <th>Vendor Name</th>
                                          <th>Vendor Person</th>
                                          <th>Mobile </th>
                                          <th>Email</th>
                                          <th>Address</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.state.pendinglistdata.length > 0 ? (
                                          this.state.pendinglistdata.map((item, index) => {
                                            return (
                                              <tr key={index}>
                                                <td>{item.purchaseInvoiceNumber}</td>
                                                <td>
                                                  {format(
                                                    new Date(item.purchaseDate),
                                                    "dd-MM-yyyy"
                                                  )}
                                                </td>
                                                <td>
                                                  {showPriceValue(item.purchaseSubtotal)}
                                                </td>
                                                <td>
                                                  {showPriceValue(item.purchaseBalanceAmount)}
                                                </td>
                                                <td>{item.vendorName}</td>
                                                <td>
                                                  {item.vendorContactPerson}
                                                </td>
                                                <td>{item.vendorPhone}</td>
                                                <td>{item.vendorEmail}</td>
                                                <td>
                                                  {item.vendorAddress}
                                                </td>
                                              </tr>
                                            );
                                          })
                                        ) : (
                                          <tr>
                                            <td className="text-center" colSpan={12}>
                                              No Receivable Bill Found
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                  <Pagenation
                                    params={{
                                      totalRecords: this.state.pendingtotalRecords,
                                      totalPage: this.state.pendingtotalPage,
                                      currentPage: this.state.pendingcurrentPage,
                                      additionalParam:'pending'
                                    }}
                                    sateValChange={this.sateValChange}
                                  />                                  
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var listdata = Array();
  var listdataStatus = "";
  var totalPages = 0;
  var totalRecords = 0;
  var totalPurchase = 0;
  if (Object.keys(state.listdata).length > 0) {
    listdataStatus = state.listdata[0].status;
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
      totalPurchase = state.listdata[0].totalPurchase;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
    totalPurchase:totalPurchase
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(List);
